import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../components/web/HomeView.vue'
import PersonalCenter from '../components/web/PersonalCenter.vue'
import aboutView from '../components/web/aboutView.vue'
import ProductCenter from '../components/web/ProductCenter.vue'
import ProcessinBase from '../components/web/ProcessinBase.vue'
import Steelknowledge from '../components/web/SteelknowledgeView.vue'
import Cooperation from '../components/web/CooperationView.vue'
import baseView from '../components/web/baseView.vue'
import baseViewB from '../components/web/baseViewB.vue'
import baseViewC from '../components/web/baseViewC.vue'
import baseViewD from '../components/web/baseViewD.vue'
import baseViewE from '../components/web/baseViewE.vue'
import loginView from '../components/loginView.vue'
import registerView from '../components/registerView.vue'
import hzyxManage from '../components/admin/hzyxManage.vue'
import SteelknowledgeSearch from '../components/web/SteelknowledgeSearch.vue'

Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    component: PersonalCenter
  },
  {
    path: '/aboutView',
    name: 'aboutView',
    component: aboutView
  },
  {
    path: '/ProductCenter',
    name: 'ProductCenter',
    component: ProductCenter
  },
  {
    path: '/ProcessinBase',
    name: 'ProcessinBase',
    component: ProcessinBase
  },
  {
    path: '/SteelknowledgeView',
    name: 'SteelknowledgeView',
    component: Steelknowledge
  },
  {
    path: '/CooperationView',
    name: 'CooperationView',
    component: Cooperation
  },
  {
    path: '/baseView',
    name: 'baseView',
    component: baseView
  },
  {
    path: '/baseViewB',
    name: 'baseViewB',
    component: baseViewB
  },
  {
    path: '/baseViewC',
    name: 'baseViewC',
    component: baseViewC
  },
  {
    path: '/baseViewD',
    name: 'baseViewD',
    component: baseViewD
  },
  {
    path: '/baseViewE',
    name: 'baseViewE',
    component: baseViewE
  },
  {
    path: '/loginView',
    name: 'loginView',
    component: loginView
  },
  {
    path: '/registerView',
    name: 'registerView',
    component: registerView
  },
  {
    path: '/hzyxManage',
    name: 'hzyxManage',
    component: hzyxManage
  },
  {
    path: '/SteelknowledgeSearch',
    name: 'SteelknowledgeSearch',
    component: SteelknowledgeSearch
  },
  
]

const router = new VueRouter({
  routes
})

export default router
